<template>
    <div class="as-emp_advanced_selector">
        <mock-el-select
            v-if="newSelect"
			slot="reference"
			size="small"
            :multiple="multiple"
			:tag-list="selectListData"
            :placeholder="placeholder"
            :collapseTags="true"
            :clearable="clearable"
			:props="{label: 'name', id: 'groupId'}"
			@close="handleTagClose"
            @clear="onClearSelectData"
			@click.native="onShowDialog"
            :wordNumber="wordNumber">
		</mock-el-select>
        <as-selector v-else :clearable="clearable" @clear="onClearSelectData" @click.native="onShowDialog" :label="label" :default="selectViewData">
            <template slot="label"><slot name="label"></slot></template>
        </as-selector>
        <as-emp-dialog-selector
            ref="dialogSelector"
            v-on="$listeners"
            v-bind="$attrs"
            v-model="dialogVisible"
            :multiple="multiple"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="defaultCheckedKeys"
            :shortcutVisible="shortcutVisible"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
            <template v-slot:node="{ node }">
                <slot name="node" :node="node"></slot>
            </template>
        </as-emp-dialog-selector>
    </div>
</template>

<script>
    import AsSelector from '@/components/selector';
    import MockElSelect from '@/components/mock-el-select';
    import AsEmpDialogSelector from '@/components/emp-dialog-selector'
    import AdvancedSelector from '@/components/advanced-selector'
    import UtilsMixins from '@/mixins/utils'
    export default {
        extends: AdvancedSelector,
        name: 'AsEmpAdvancedSelector',
        props: {
            filterEmpData: Function,
            shortcutVisible: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: Boolean,
                default: true,
            },
            newSelect: {
                type: Boolean,
                default: false
            },
            wordNumber: {
                type: Number,
                default: 30
            }
        },
        components: {
            AsSelector,
            AsEmpDialogSelector,
            MockElSelect
        },
        mixins: [UtilsMixins],
        computed: {
            selectViewData() {
                const label = 'name';
                const count = this.selectListData ? this.selectListData.length : 0;
                if (!count) return this.defaultSelectData;
                const appendFixLabel = count > 1 ? `+ ${count - 1}` : '';
                const name = `${this.selectListData[0][label]}${appendFixLabel}`;
                return {
                    name,
                }
            },
        },
        methods: {
            handleTagClose(index) {
                this.selectListData.splice(index, 1);
                this.triggerEvent(this.selectListData);
            },
             onClearSelectData() {
                this.clear();
            },
            loadAdminAndEmployeeData(data) {
                const { adminList, empList } = data;
                const shopIdMap = {};
                const roleMap = {};
                const roleGroupDataMap = {};
                const sidebarList = [];
                let listData = [];
                if (adminList && adminList.length > 0) {
                    listData = listData.concat(adminList)
                }
                if (empList && empList.length > 0) {
                    listData = listData.concat(empList);
                }
                listData.forEach(empData => {
                    const { shopid, shopId, shopName, roleStr } = empData;
                    const empShopId = Number(shopid || shopId);
                    empData.shopId = Number(empShopId);
                    if (!this.filterEmpData || this.filterEmpData(empData)) {
                        const groupId = `${empShopId}-${roleStr}`;
                        empData.groupId = groupId;
                        if (empData.type === 0) {
                            empData.status = 1;
                        }
                        roleMap[groupId] = {
                            name: roleStr,
                            id: groupId
                        }
                        if (!roleGroupDataMap[groupId]) {
                            roleGroupDataMap[groupId] = [];
                        }
                        roleGroupDataMap[groupId].push(empData);
                        if (!shopIdMap[empShopId]) {
                            sidebarList.push({
                                id: empShopId,
                                osname: shopName,
                            })
                            shopIdMap[empShopId] = 1;
                        }
                    }
                })

                const contentData = Object.keys(roleMap).map(groupId => {
                    const groupData = roleMap[groupId];
                    groupData.children = roleGroupDataMap[groupId];
                    return groupData;
                })
                this.dialogLoading = false;
                this.loadSelectorData = contentData;
                this.loadSidebarData = sidebarList;
            },
            loadDataCallback(listData, options) {
                if (options && options.hasAdmin) {
                    this.loadAdminAndEmployeeData(listData);
                    return;
                }
                let sidebarList = [];
                let shopIdMap = {};
                let contentData = [];
				if (listData.level === 2) {
					listData = {
						children: [ {
							children: [listData]
						}]
					}
				}
                listData.children.forEach(areaData => {
                    if (areaData.children) {
                        areaData.children.forEach(shopData => {
                            const { id, children } = shopData;
							shopData.viewName = this.getShopNameByData(shopData);
                            if (children && !shopIdMap[id]) {
                                const shopChildren = children.reduce((listData, departmentData) => {
                                    const children = departmentData.children || [];
                                    const filterChildren = children.filter(posData => {
										posData.id = `${posData.shopId}-${posData.id}`;
                                        let { children: posChildren } = posData;
                                        if (posChildren && posChildren.length > 0) {
											posChildren = posChildren.filter(empData => {
												empData.barberLevelName = posData.name;
												empData.groupId = posData.id;
												return !this.filterEmpData || this.filterEmpData(empData)

											})
											if (posChildren.length > 0) {
												return true;
											}
                                        }
                                    })
                                    listData.push(...filterChildren);
                                    return listData;
                                }, []);
                                if (shopChildren.length) {
                                    shopIdMap[id] = 1;
                                    sidebarList.push({
                                        osname: shopData.viewName,
										id,
                                    })
                                    contentData.push(...shopChildren);
                                }
                            }
                        })
                    }
                })
                this.dialogLoading = false;
                this.loadSelectorData = contentData;
                this.loadSidebarData = sidebarList;
            },
        },
    }
</script>
<style lang="scss">
.as-emp_advanced_selector {
    display: inline-flex;
}
</style>